import {Model} from '@/models/Model'
import {DataArray, DataResource, FilterSet} from '@/models/Response'
import Helper from '../services/Helper.js'


export const TruckConst = Object.freeze({
  TYPE_TEST: 20,

  ENABLE_ALL: 9,
  ENABLE_IF_ABLE: 4,
  ENABLE_NONE: 0,

  PROVINCE_ALL: 0,
  PROVINCE_NEAR: 1,
  PROVINCE_FAR: 2,
  PROVINCE_MIDDLE: 3,


  map(type: string): string {
    const map = {
      'VAN': 'รถตู้',
      'ICE-CREAM': 'รถไอติม',
      'SINGLE-HEAD': 'รถกระบะหัวเดี่ยว',
      'CAB': 'รถกระบะมี CAB',
      'SMALL-4WL': 'รถ 4 ล้อเล็ก',
      'MEDIUM-4WL': 'รถ 4 ล้อกลาง',
      'MEDIUM-6WL': 'รถ 6 ล้อ',
      'SERVICE-CAB': 'รถช่าง',
      'CAR': 'รถเก๋ง',
      'TRAY-4WL': 'รถ 4 ล้อ คอก',
      'LARGE-10WL': 'รถ 10 ล้อ',
    }
    return map[type]
  },
})


export class Truck extends Model {
  declare id: number | null
  created_at: Date | null
  updated_at: Date | null
  name: string | null
  plate: string | null
  enabled: boolean | null
  truck_weight: number | null
  type: string | null
  user_code: string | null
  driver_name: string | null
  remark: string | null
  max_weight: number | null
  max_cbm: number | null
  speed_kmh: number | null
  driver_amount: number | null
  consumption_per_km: number | null
  status: string | null
  available_datetime: Date | string | null

  wage_per_day: number | null

  mt_enabled: number | null
  pj_enabled: number | null

  checked: boolean | null
  erp_code: string | null

  province_enabled: number | null

  transport_routes: any | null

  getResourceURL(): string {
    return Helper.setting.truck.getResourceAPI
  }


}

export class DataTrucksArray extends DataArray {

  declare data: Truck[]
  filter: FilterTruck = new FilterTruck()
}


export class FilterTruck {
  price_group: FilterSet = new FilterSet()
}


export class DataTruck extends DataResource {

  declare data: Truck

}
